import React, { useContext, useState } from 'react';
import { Typography, IconButton, Dialog, dialogClasses, DialogActions, DialogContent, Button, DialogTitle, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { DatasetSelectionCtx, emptyFileSelection, emptyDatasetSelection, FileSelectionCtx, NotebookFeedbackCtx, } from '../../App/ApplicationContext';
import { DownloadUI } from '../Processing/DownloadUI';
import { NotebookUI } from '../Processing/NotebookUI';
import SearchResults from './SearchResults';
import { SubsettingForm } from '../Subsetting/SubsettingForm';
import GetFilesForQuery from '../GetFilesForQuery';
import { DEFAULTCOORDINATES, DEFAULTDATE, } from '../../../types/dataTypes';
import { Status, OUTPUT, OPERATION, SUBSETTING, } from '../../../types/searchTypes';
const classes = {
    root: {
        width: '100%',
        minHeight: '20vh',
    },
    closeButton: {
        position: 'absolute',
        right: '4px',
        top: '4px',
        color: '#9e9e9e',
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        minWidth: '95vw',
        maxWidth: '95vw',
    },
    dialogTitle: {
        color: '#fff',
        backgroundColor: '#3f51b5',
        fontWeight: 400,
    },
    dialogContent: {
        padding: '0px',
    },
    dialogFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '8px',
        backgroundColor: '#f5f5f5',
    },
    button: {
        marginLeft: '10px',
    },
};
const ResultsTitle = ({ closeAndClear, operation }) => {
    return (React.createElement(DialogTitle, { id: 'simple-dialog-title', sx: classes.dialogTitle },
        React.createElement(Typography, { align: 'center' }, operation === OPERATION.SUBSETTING
            ? 'Subsetting Selection'
            : 'Search results'),
        React.createElement(IconButton, { "aria-label": 'Close', sx: classes.closeButton, onClick: closeAndClear },
            React.createElement(CloseIcon, { style: { color: 'white' } }))));
};
export const ResultsWindow = ({ searchQuery, projectType, nodes, handleClose, operation, user, subsettingMode, }) => {
    const { notebookProperties, setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const { fileCollection, selectFiles } = useContext(FileSelectionCtx);
    const { datasetCollection, selectDatasets } = useContext(DatasetSelectionCtx);
    const [subsetFormOpen, setSubsetFormOpen] = React.useState(false);
    const [subsettingParameters, setSubsettingParameters] = useState(Object.assign(Object.assign(Object.assign({}, DEFAULTCOORDINATES), DEFAULTDATE), { name: '', message: '' }));
    const closeAndClear = () => {
        selectFiles(emptyFileSelection);
        selectDatasets(emptyDatasetSelection);
        handleClose();
    };
    const queryLimit = 500;
    const datasetSelectionIsEmpty = !datasetCollection.length;
    const selectionIsEmpty = !fileCollection.length && datasetSelectionIsEmpty;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { onClose: closeAndClear, "aria-labelledby": 'Search Results', open: true, sx: { [`& .${dialogClasses.paper}`]: classes.dialogPaper } },
            React.createElement(ResultsTitle, { closeAndClear: closeAndClear, operation: operation }),
            React.createElement(DialogContent, { sx: classes.dialogContent },
                React.createElement(SearchResults, { searchQuery: searchQuery, project: projectType, nodes: nodes, operation: operation })),
            React.createElement(DialogActions, { sx: classes.dialogFooter },
                React.createElement(Button, { onClick: closeAndClear, color: 'secondary' }, "Close"),
                React.createElement("div", null, operation === OPERATION.DOWNLOAD ? (React.createElement(React.Fragment, null,
                    React.createElement(Button, { disabled: selectionIsEmpty, startIcon: React.createElement(GetAppIcon, null), variant: 'contained', sx: classes.button, onClick: () => {
                            setNotebookProperties(Object.assign(Object.assign({}, notebookProperties), { processingStatus: Status.IDLE, redirectUrl: notebookProperties.redirectUrl, dialogOpen: true, output: OUTPUT.FILELIST }));
                        }, color: 'primary' }, "Link list"),
                    React.createElement(Button, { disabled: selectionIsEmpty || !user || !user.registered, startIcon: React.createElement(ExitToAppIcon, null), sx: classes.button, variant: 'contained', onClick: () => {
                            setNotebookProperties(Object.assign(Object.assign({}, notebookProperties), { processingStatus: Status.IDLE, redirectUrl: notebookProperties.redirectUrl, dialogOpen: true, output: OUTPUT.NOTEBOOK }));
                        }, color: 'primary' }, "Export to notebook"))) : (React.createElement(Button, { disabled: datasetSelectionIsEmpty, startIcon: React.createElement(AccountTreeIcon, null), sx: classes.button, variant: 'contained', onClick: () => {
                        setSubsetFormOpen(true);
                    }, color: 'primary' }, "Set Parameters"))))),
        notebookProperties.dialogOpen &&
            operation === OPERATION.DOWNLOAD &&
            notebookProperties.output === OUTPUT.FILELIST && (React.createElement("div", { style: classes.root },
            React.createElement(GetFilesForQuery, { searchQuery: searchQuery, project: projectType, nodes: nodes, queryLimit: queryLimit, operation: OPERATION.DOWNLOAD }, (fileListObject, completed, myQueryLimit) => (React.createElement(DownloadUI, Object.assign({}, { completed, fileListObject, myQueryLimit })))))),
        notebookProperties.dialogOpen &&
            operation === OPERATION.DOWNLOAD &&
            notebookProperties.output === OUTPUT.NOTEBOOK && (React.createElement("div", { style: classes.root },
            React.createElement(GetFilesForQuery, { searchQuery: searchQuery, project: projectType, nodes: nodes, queryLimit: queryLimit, operation: OPERATION.DOWNLOAD }, (fileListObject, completed, myQueryLimit) => (React.createElement(NotebookUI, Object.assign({ handleClose: handleClose }, {
                fileListObject,
                completed,
                myQueryLimit,
                operation,
            }, { subsettingParameters: {}, subsettingMode: SUBSETTING.NONE })))))),
        notebookProperties.dialogOpen && operation === OPERATION.SUBSETTING && (React.createElement("div", { style: classes.root },
            React.createElement(GetFilesForQuery, { searchQuery: searchQuery, project: projectType, nodes: nodes, queryLimit: queryLimit, operation: OPERATION.SUBSETTING }, (fileListObject, completed, myQueryLimit) => (React.createElement(NotebookUI, Object.assign({ operation: operation, handleClose: handleClose, subsettingMode: subsettingMode, subsettingParameters: subsettingParameters }, { fileListObject, completed, myQueryLimit })))))),
        subsetFormOpen && (React.createElement(SubsettingForm, { setSubsetFormOpen: setSubsetFormOpen, setSubsettingParameters: setSubsettingParameters, setNotebookProperties: setNotebookProperties, redirectUrl: notebookProperties.redirectUrl, subsettingMode: subsettingMode })),
        ")"));
};
export default ResultsWindow;
